import { Asset } from '../../models/Asset'

export default function isAssetVisible({ visibleFrom, visibleUntil }: Pick<Asset, 'visibleFrom' | 'visibleUntil'>) {
  if (visibleFrom && visibleFrom.valueOf() > new Date().valueOf()) {
    return false
  }
  if (visibleUntil && visibleUntil.valueOf() < new Date().valueOf()) {
    return false
  }
  return true
}
